export default __webpack_public_path__ + "static/media/My-Cart.e0bf4286.jpg";